import { PagedSearch } from 'src/app/shared';

export class CommitteeMeetingMemberAttendanceSearchDto extends PagedSearch {
  MeetingID: number;
}
